import React from 'react';

function Mensajes(props) {
    return (
        <div class="card list-inline-item">
            <div class="card-header d-flex justify-content-between">
                <h5 class="card-title m-0 me-2">Mensajes</h5>
                <div class="dropdown">
                    <button class="btn text-body-secondary p-0" type="button" id="timelineWapper" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="icon-base bx bx-dots-vertical-rounded icon-lg"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-end" aria-labelledby="timelineWapper">
                        <a class="dropdown-item" href="javascript:void(0);">Select All</a>
                        <a class="dropdown-item" href="javascript:void(0);">Refresh</a>
                        <a class="dropdown-item" href="javascript:void(0);">Share</a>
                    </div>
                </div>
            </div>
            <div class="card-body pt-2">
                <ul class="timeline mb-0">
                    <li class="timeline-item mb-2">
                        <span class="timeline-point"></span>
                        <div class="timeline-event">
                            <div class="timeline-header mb-3">
                                <h6 class="mb-0">12 Invoices have been paid</h6>
                                <small class="text-body-secondary">12 min ago</small>
                            </div>
                            <div class="d-flex justify-content-between flex-wrap gap-2">
                                <div class="d-flex flex-wrap align-items-center">
                                    <div class="avatar avatar-sm me-2">
                                        <img src="../../assets/img/avatars/1.png" alt="Avatar" class="rounded-circle" />
                                    </div>
                                    <div>
                                        <p class="mb-0 small fw-medium">Jhon Doe (Propietario)</p>
                                        <small>5-731</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                </ul>
            </div>
        </div>
    );
}

export default Mensajes;